// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__evKRa","insightsList":"newBusinessInsightsMenu_insightsList__3JR0B","active":"newBusinessInsightsMenu_active__1uxZv"};